// api.js
import axios from 'axios';

export function LogoutOnUnauthorizedResponse() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('username');
    window.location.href = '/';
    //setAuthToken(null);
    //setAppUserName(null);
  } 


// Создаём экземпляр Axios
const axios_api = axios.create({});

// Настраиваем интерсептор для ответов
axios_api.interceptors.response.use(
  (response) => {
    // Если ответ успешный, просто возвращаем его
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      LogoutOnUnauthorizedResponse(); // Вызываем Logout
    }
    // Возвращаем ошибку для дальнейшей обработки 
    return Promise.reject(error);
  }
);

export default axios_api;